import { EnrollmentCard } from '@/components/services/enrollment-card';
import { EmptyState } from '@/components/ui/empty-state';
import { ErrorState } from '@/components/ui/error-state';
import { FadeInView } from '@/components/ui/fade-in-view';
import { PageLayout } from '@/components/ui/page-layout';
import { Pagination } from '@/components/ui/pagination';
import { SkeletonCard } from '@/components/ui/skeleton';
import { useProviderEnrollments } from '@/hooks/use-enrollments';
import { useTerms } from '@/hooks/use-terms';
import { router } from 'expo-router';
import React, { useState } from 'react';
import { StaticList } from '@/components/ui/static-list';
import { View } from 'react-native';

const DEFAULT_ITEMS_PER_PAGE = 10;

export default function ProviderEnrollmentsScreen() {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const terms = useTerms();

  const {
    data: paginatedData,
    isLoading,
    error,
    refetch,
  } = useProviderEnrollments({
    page: currentPage,
    limit: itemsPerPage,
  });

  const enrollments = paginatedData?.data || [];
  const totalPages = paginatedData?.meta?.totalPages || 0;

  const handleNewEnrollment = () => {
    router.push('/(tabs)/(provider)/enrollments/new');
  };

  return (
    <PageLayout
      title={terms.title.enrollmentPlural}
      subtitle={`Acompanhe ${terms.agree('seus', 'enrollment')} ${terms.enrollmentPlural} e pagamentos`}
      buttonTitle={`Criar ${terms.enrollment}`}
      onButtonPress={handleNewEnrollment}
      buttonTestID="enrollment-list-new-contract-btn"
    >
      {isLoading ? (
        <View className="gap-3">
          {Array.from({ length: 5 }).map((_, index) => (
            <SkeletonCard key={index} showHeader={true} showFooter={false} lines={2} />
          ))}
        </View>
      ) : error ? (
        <ErrorState
          variant="inline"
          title={`Erro ao carregar ${terms.enrollmentPlural}`}
          message={`Não foi possível carregar ${terms.agree('os', 'enrollment')} ${terms.enrollmentPlural}. Tente novamente.`}
          onRetry={refetch}
        />
      ) : enrollments.length === 0 ? (
        <EmptyState
          icon="document-text-outline"
          title={`${terms.agree('Nenhum', 'enrollment')} ${terms.enrollment} ainda`}
          description={`Crie ${terms.agree('um', 'enrollment')} ${terms.enrollment} para começar a receber ${terms.agree('dos', 'client')} ${terms.agree('seus', 'client')} ${terms.clientPlural}.`}
          actionLabel={`Criar ${terms.enrollment}`}
          onAction={handleNewEnrollment}
          className="py-12"
        />
      ) : (
        <>
          <StaticList
            data={enrollments}
            keyExtractor={(item) => item.id}
            renderItem={(item, index) => (
              <FadeInView key={item.id} delay={index * 50}>
                <EnrollmentCard enrollment={item} size="large" />
              </FadeInView>
            )}
          />
          <View className="mt-2">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages || 1}
              onPageChange={setCurrentPage}
              itemsPerPage={itemsPerPage}
              onItemsPerPageChange={setItemsPerPage}
              itemsPerPageOptions={[10, 20, 50, 100]}
            />
          </View>
        </>
      )}
    </PageLayout>
  );
}
